export default __webpack_public_path__ + "static/media/1896.7d82c9fb.png";